export default __webpack_public_path__ + "static/media/FDL_Green.090a3be4.png";